import {
    Edit,
    SimpleForm,
    TextInput,
    Datagrid,
    List,
    TextField,
    NumberField,
    ImageField,
    RichTextField,
    NumberInput,
    ImageInput,
  } from "react-admin";

export const RESOURCEID="itemId";

export const ItemList = () => (
    <List>
        <Datagrid rowClick="edit">
            <TextField source="name" />
            <ImageField source="image" src="image" title="desc" />
            <NumberField source="price" />
            <TextField source="style" />
            <TextField source="categoryPath" />
        </Datagrid>
    </List>)

export const ItemEdit = () => (
    <Edit>
      <SimpleForm>
            <TextField source="id" />
            <TextField label={RESOURCEID} source={RESOURCEID} />
            <TextInput source="name" />
            <RichTextField source="description" />
            <NumberInput source="price" />
            <TextInput source="productLink" />
            <ImageInput source="image">
              <ImageField source="image" src="image" title="desc" />
            </ImageInput>
            <TextInput source="style" />
            <TextField source="categoryPath" />
      </SimpleForm>
    </Edit>
  );